import React from "react";
import styles from "./ThankYouModal.module.css";

interface ThankYouModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ThankYouModal: React.FC<ThankYouModalProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.content}>
          <div className={styles.iconContainer}>
            <svg
              width="17"
              height="24"
              viewBox="0 0 17 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.5 22.4993L7 14.9993L1 12.7493L11.5 1.49927L10 8.99927L16 11.2493L5.5 22.4993Z"
                stroke="#959000"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <div className={styles.textContent}>
            <div className={styles.title}>Спасибо за помощь!</div>
            <div className={styles.subtitle}>Мы сохранили локацию</div>
          </div>
        </div>

        <button className={styles.confirmButton} onClick={onClose}>
          Вернуться на карту
        </button>
      </div>
    </div>
  );
};
